export default "__VITE_ASSET__DS9Elm56__"